import styled from "styled-components";

export const getStyledContentWrapper = (size: boolean) => styled.div`
    display: flex;
    flex-direction: ${size ? 'column' : 'column-reverse'};
`